import { AWARD } from "../data/rooms";

// Official Coliving Awards badge (gold line-art on transparent). Sits on a cream plate so it reads on any background.
const OfficialAwardBadge = ({ className = "", plate = true, testid = "official-award-badge", width = 280, alt }) => (
  <a
    href="https://colivingawards.com"
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-block ${plate ? "bg-[#FBF7F1]/95 backdrop-blur-sm rounded-md shadow-lg shadow-black/20 px-4 py-3" : ""} ${className}`}
    data-testid={testid}
    aria-label={`${AWARD.body} ${AWARD.year} ${AWARD.status}: ${AWARD.category}`}
  >
    <img
      src="/images/coliving-awards-2026-winner.webp"
      alt={alt || `${AWARD.body} ${AWARD.year} ${AWARD.status} — ${AWARD.category}`}
      width={width}
      height={Math.round(width * 379 / 1200)}
      className="block h-auto select-none"
      style={{ width }}
      loading="lazy"
      decoding="async"
    />
  </a>
);

export default OfficialAwardBadge;
